import React from 'react';

import QntClientsReport from '../BotReport/Components/Reports/QntClientsReport';
import QntClientsGraphic from '../BotReport/Components/Graphics/QntClientsGraphic';
import QntMessageReport from '../BotReport/Components/Reports/QntMessageReport';
import QntMessageGraphic from '../BotReport/Components/Graphics/QntMessageGraphic';
import QntSessionReport from '../BotReport/Components/Reports/QntSessionReport';
import QntSessionGraphic from '../BotReport/Components/Graphics/QntSessionGraphic';
import QntMessageChannelReport from '../BotReport/Components/Reports/QntMessageChannelReport';
import QntMessageChannelGraphic from '../BotReport/Components/Graphics/QntMessageChannelGraphic';
import AttendanceTimeReportHuman from '../BotReport/Components/Reports/AttendanceTime/AttendanceTimeReportHuman';
import AttendanceTimeReportBot from '../BotReport/Components/Reports/AttendanceTime/AttendanceTimeReportBot';
import SessionAttendanceTime from '../BotReport/Components/Reports/AttendanceTime/SessionAttendanceTime';
import QueueTimeAttendanceTime from '../BotReport/Components/Reports/AttendanceTime/QueueTimeAttendanceTime';
import AttendanceTimeGraphic from '../BotReport/Components/Graphics/AttendanceTimeGraphic';
import TagsGraphic from '../BotReport/Components/Graphics/TagsGraphic';

// import NotUnderstood from '../IaReport/NotUnderstood';
// import UseIntentions from '../IaReport/UseIntentions';
// import PerformanceIntentions from '../IaReport/PerformanceIntentions';

import OrgBotsNumberReport from '../OrgReport/OrgBotsReport/Components/Reports/OrgBotsNumberReport';
import OrgBotsTotalMessagesReport from '../OrgReport/OrgBotsReport/Components/Reports/OrgBotsTotalMessagesReport';
import OrgBotsTotalMessagesGraphic from '../OrgReport/OrgBotsReport/Components/Graphics/OrgBotsTotalMessagesGraphic';
import OrgBotsTotalMessagesByChannelReport from '../OrgReport/OrgBotsReport/Components/Reports/OrgBotsTotalMessagesByChannelReport';
import OrgBotsTotalMessagesByChannelGraphic from '../OrgReport/OrgBotsReport/Components/Graphics/OrgBotsTotalMessagesByChannelGraphic';
import OrgBotsTotalSessionsReport from '../OrgReport/OrgBotsReport/Components/Reports/OrgBotsTotalSessionsReport';
import OrgBortsTotalSessionsGraphic from '../OrgReport/OrgBotsReport/Components/Graphics/OrgBortsTotalSessionsGraphic';
import OrgTotalUsersReport from '../OrgReport/OrgUsersReport/Components/Report/OrgTotalUsersReport';
import OrgListUsers from '../OrgReport/OrgUsersReport/Components/OrgListUsers';
import OrgTotalBotsUser from '../OrgReport/OrgUsersReport/Components/OrgTotalBotsUser';

import {
  botPages,
  botsSubPages,
  aiSubPages,
  orgPages,
  orgBotsSubPages,
  orgUsersSubPages,
} from '../MainScreenReport/index';

export const dashboardType = {
  BOT: 'botDashboard',
  ORG: 'orgDashboard',
};

export const reportComponentsIds = {
  [botsSubPages.BOT_NUMBER_OF_CLIENTS]: {
    QUANT_CLIENTS_REPORT: 'qntClientsReport',
    QUANT_CLIENTS_GRAPHIC: 'qntClientsGraphic',
  },
  [botsSubPages.BOT_NUMBER_OF_MESSAGES]: {
    QUANT_MESSAGE_REPORT: 'qntMessageReport',
    QUANT_MESSAGE_GRAPHIC: 'qntMessageGraphic',
  },
  [botsSubPages.BOT_NUMBER_OF_SESSIONS]: {
    QUANT_SESSION_REPORT: 'qntSessionReport',
    QUANT_SESSION_GRAPHIC: 'qntSessionGraphic',
  },
  [botsSubPages.BOT_NUMBER_OF_MESSAGES_BY_CHANNEL]: {
    QUANT_MESSAGE_CHANNEL_REPORT: 'qntMessageChannelReport',
    QUANT_MESSAGE_CHANNEL_GRAPHIC: 'qntMessageChannelGraphic',
  },
  [botsSubPages.BOT_ATTENDANCE_TIME]: {
    ATTENDANCE_TIME_REPORT_HUMAN: 'attendanceTimeReportHuman',
    ATTENDANCE_TIME_REPORT_BOT: 'attendanceTimeReportBot',
    SESSION_ATTENDANCE_TIME: 'sessionAttendanceTime',
    ATTENDANCE_TIME_GRAPHIC: 'attendanceTimeGraphic',
    QUEUE_ATTENDANCE_TIME: 'queueAtendanceTime',
  },
  [botsSubPages.BOT_TAGS]: {
    TAGS_GRAPHIC: 'tagsGraphic',
  },
  [aiSubPages.AI_NOT_UNDERSTOOD]: {
    NOT_UNDERSTOOD_GRAPHIC: 'notUnderstood',
  },
  [aiSubPages.AI_USE_OF_INTENTIONS]: {
    USE_INTENTIONS_GRAPHIC: 'useIntentions',
  },
  [aiSubPages.AI_INTENTION_PERFORMANCE]: {
    PERFORMANCE_INTENTIONS_GRAPHIC: 'performanceIntentions',
  },
  [orgBotsSubPages.ORG_BOTS_NUMBER]: {
    ORG_BOTS_NUMBER_REPORT: 'orgBotsNumberReport',
  },
  [orgBotsSubPages.ORG_BOTS_TOTAL_MESSAGES]: {
    ORG_TOTAL_MESSAGES_REPORT: 'orgTotalMessagesReport',
    ORG_TOTAL_MESSAGES_GRAPHIC: 'orgTotalMessagesGraphic',
  },
  [orgBotsSubPages.ORG_BOTS_TOTAL_MESSAGES_BY_CHANNEL]: {
    ORG_TOTAL_MESSAGES_BY_CHANNEL_REPORT: 'orgTotalMessagesByChannelReport',
    ORG_TOTAL_MESSAGES_BY_CHANNEL_GRAPHIC: 'orgTotalMessagesByChannelGraphic',
  },
  [orgBotsSubPages.ORG_BOTS_TOTAL_SESSIONS]: {
    ORG_TOTAL_SESSIONS_REPORT: 'orgTotalSessionsReport',
    ORG_TOTAL_SESSIONS_GRAPHIC: 'orgTotalSessionsGraphic',
  },
  [orgUsersSubPages.ORG_TOTAL_USERS]: {
    ORG_TOTAL_USERS_REPORT: 'orgBotsNumberReport',
  },
  [orgUsersSubPages.ORG_LIST_USERS]: {
    ORG_LIST_USERS: 'orgListUsers',
  },
  [orgUsersSubPages.ORG_BOT_USERS]: {
    ORG_BOT_USERS: 'orgBotUsers',
  },
};

const reportType = {
  ABSOLUTE: 'absolute',
  GRAPHIC: 'graphic',
  CUSTOM: 'custom',
};

const reportTypeText = {
  absolute: 'Absoluto',
  graphic: 'Gráfico',
  custom: (name) => name,
};

/** Object for holding the dashboard data information on bot dashboard when create the screen */
export const botDashboardOptions = [
  {
    id: botPages.BOT,
    dashboardType: dashboardType.BOT,
    title: 'Relatório do bot',
    reports: [
      {
        componentName: botsSubPages.BOT_NUMBER_OF_CLIENTS,
        title: 'Quantidade de clientes',
        options: [
          {
            componentId:
              reportComponentsIds.botNumberClients.QUANT_CLIENTS_REPORT,
            draggableId: 'qnt-clients-absolute-id',
            type: reportType.ABSOLUTE,
            typeText: reportTypeText[reportType.ABSOLUTE],
            component: (componentData) => (
              <QntClientsReport componentData={componentData} />
            ),
          },
          {
            componentId:
              reportComponentsIds.botNumberClients.QUANT_CLIENTS_GRAPHIC,
            draggableId: 'qnt-clients-graphic-id',
            type: reportType.GRAPHIC,
            typeText: reportTypeText[reportType.GRAPHIC],
            component: (componentData) => (
              <QntClientsGraphic componentData={componentData} hideDownload />
            ),
          },
        ],
      },
      {
        componentName: botsSubPages.BOT_NUMBER_OF_MESSAGES,
        title: 'Quantidade de mensagens',
        options: [
          {
            componentId:
              reportComponentsIds.botNumberMessages.QUANT_MESSAGE_REPORT,
            draggableId: 'qnt-messages-absolute-id',
            type: reportType.ABSOLUTE,
            typeText: reportTypeText[reportType.ABSOLUTE],
            component: (componentData) => (
              <QntMessageReport componentData={componentData} />
            ),
          },
          {
            componentId:
              reportComponentsIds.botNumberMessages.QUANT_MESSAGE_GRAPHIC,
            draggableId: 'qnt-messages-graphic-id',
            type: reportType.GRAPHIC,
            typeText: reportTypeText[reportType.GRAPHIC],
            component: (componentData) => (
              <QntMessageGraphic componentData={componentData} hideDownload />
            ),
          },
        ],
      },
      {
        componentName: botsSubPages.BOT_NUMBER_OF_SESSIONS,
        title: 'Quantidade de sessões',
        options: [
          {
            componentId:
              reportComponentsIds.botNumberSessions.QUANT_SESSION_REPORT,
            draggableId: 'qnt-sessions-absolute-id',
            type: reportType.ABSOLUTE,
            typeText: reportTypeText[reportType.ABSOLUTE],
            component: (componentData) => (
              <QntSessionReport componentData={componentData} />
            ),
          },
          {
            componentId:
              reportComponentsIds.botNumberSessions.QUANT_SESSION_GRAPHIC,
            draggableId: 'qnt-sessions-graphic-id',
            type: reportType.GRAPHIC,
            typeText: reportTypeText[reportType.GRAPHIC],
            component: (componentData) => (
              <QntSessionGraphic componentData={componentData} hideDownload />
            ),
          },
        ],
      },
      {
        componentName: botsSubPages.BOT_NUMBER_OF_MESSAGES_BY_CHANNEL,
        title: 'Quant. de mensagens por canal',
        options: [
          {
            componentId:
              reportComponentsIds.botNumberMessagesByChannel
                .QUANT_MESSAGE_CHANNEL_REPORT,
            draggableId: 'qnt-messages-channel-absolute-id',
            type: reportType.ABSOLUTE,
            typeText: reportTypeText[reportType.ABSOLUTE],
            component: (componentData) => (
              <QntMessageChannelReport componentData={componentData} />
            ),
          },
          {
            componentId:
              reportComponentsIds.botNumberMessagesByChannel
                .QUANT_MESSAGE_CHANNEL_GRAPHIC,
            draggableId: 'qnt-messages-channel-graphic-id',
            type: reportType.GRAPHIC,
            typeText: reportTypeText[reportType.GRAPHIC],
            component: (componentData) => (
              <QntMessageChannelGraphic
                componentData={componentData}
                hideDownload
              />
            ),
          },
        ],
      },
      {
        componentName: botsSubPages.BOT_ATTENDANCE_TIME,
        title: 'Tempo de atendimento',
        options: [
          {
            componentId:
              reportComponentsIds.botAttendanceTime.ATTENDANCE_TIME_REPORT_HUMAN,
            draggableId: 'attendance-time-absolute-human-id',
            type: reportType.ABSOLUTE,
            typeText: reportTypeText[reportType.ABSOLUTE],
            component: (componentData) => (
              <AttendanceTimeReportHuman componentData={componentData} />
            ),
          },
          {
            componentId:
              reportComponentsIds.botAttendanceTime.ATTENDANCE_TIME_REPORT_BOT,
            draggableId: 'attendance-time-absolute-bot-id',
            type: reportType.ABSOLUTE,
            typeText: reportTypeText[reportType.ABSOLUTE],
            component: (componentData) => (
              <AttendanceTimeReportBot componentData={componentData} />
            ),
          },
          {
            componentId:
              reportComponentsIds.botAttendanceTime.SESSION_ATTENDANCE_TIME,
            draggableId: 'session-attendance-time-absolute-id',
            type: reportType.ABSOLUTE,
            typeText: reportTypeText[reportType.ABSOLUTE],
            component: (componentData) => (
              <SessionAttendanceTime componentData={componentData} />
            ),
          },
          {
            componentId:
              reportComponentsIds.botAttendanceTime.QUEUE_ATTENDANCE_TIME,
            draggableId: 'queue-attendance-time-absolute-id',
            type: reportType.ABSOLUTE,
            typeText: reportTypeText[reportType.ABSOLUTE],
            component: (componentData) => (
              <QueueTimeAttendanceTime componentData={componentData} />
            ),
          },
          {
            componentId:
              reportComponentsIds.botAttendanceTime.ATTENDANCE_TIME_GRAPHIC,
            draggableId: 'attendance-time-graphic-id',
            type: reportType.GRAPHIC,
            typeText: reportTypeText[reportType.GRAPHIC],
            component: (componentData) => (
              <AttendanceTimeGraphic
                componentData={componentData}
                hideDownload
              />
            ),
          },
        ],
      },
      {
        componentName: botsSubPages.BOT_TAGS,
        title: 'Tags',
        options: [
          {
            componentId: reportComponentsIds.botAttendanceTime.TAGS_GRAPHIC,
            draggableId: 'tags-graphic-id',
            type: reportType.GRAPHIC,
            typeText: reportTypeText[reportType.GRAPHIC],
            component: (componentData) => (
              <TagsGraphic componentData={componentData} hideDownload />
            ),
          },
        ],
      },
    ],
  },
  // {
  //   id: botPages.AI,
  //   dashboardType: dashboardType.BOT,
  //   title: 'Relatório de I.A',
  //   reports: [
  //     {
  //       componentName: aiSubPages.AI_NOT_UNDERSTOOD,
  //       title: 'Não entendidas',
  //       options: [
  //         {
  //           componentId:
  //             reportComponentsIds.aiNotUnderstood.NOT_UNDERSTOOD_GRAPHIC,
  //           draggableId: 'not-understood-graphic-id',
  //           type: reportType.GRAPHIC,
  //           typeText: reportTypeText[reportType.GRAPHIC],
  //           component: (parentFilter) => (
  //             <NotUnderstood parentFilter={parentFilter} hideDownload />
  //           ),
  //         },
  //       ],
  //     },
  //     {
  //       componentName: aiSubPages.AI_USE_OF_INTENTIONS,
  //       title: 'Uso de intenções',
  //       options: [
  //         {
  //           componentId:
  //             reportComponentsIds.aiUseIntentions.USE_INTENTIONS_GRAPHIC,
  //           draggableId: 'use-intentions-graphic-id',
  //           type: reportType.GRAPHIC,
  //           typeText: reportTypeText[reportType.GRAPHIC],
  //           component: (parentFilter) => (
  //             <UseIntentions parentFilter={parentFilter} hideDownload />
  //           ),
  //         },
  //       ],
  //     },
  //     {
  //       componentName: aiSubPages.AI_INTENTION_PERFORMANCE,
  //       title: 'Desempenho de intenções',
  //       options: [
  //         {
  //           componentId:
  //             reportComponentsIds.aiIntentionPerformance
  //               .PERFORMANCE_INTENTIONS_GRAPHIC,
  //           draggableId: 'performance-intentions-graphic-id',
  //           type: reportType.GRAPHIC,
  //           typeText: reportTypeText[reportType.GRAPHIC],
  //           component: (parentFilter) => (
  //             <PerformanceIntentions parentFilter={parentFilter} hideDownload />
  //           ),
  //         },
  //       ],
  //     },
  //   ],
  // },
];

/** Object for holding the dashboard data information on org dashboard when create the screen */
export const orgDashboardOptions = [
  {
    id: orgPages.BOTS,
    dashboardType: dashboardType.ORG,
    title: 'Bots',
    reports: [
      {
        componentName: orgBotsSubPages.ORG_BOTS_NUMBER,
        title: 'Número de Bots',
        options: [
          {
            componentId:
              reportComponentsIds.orgBotsNumber.ORG_BOTS_NUMBER_REPORT,
            draggableId: 'org-bots-number',
            type: reportType.ABSOLUTE,
            typeText: reportTypeText[reportType.ABSOLUTE],
            component: (componentData) => (
              <OrgBotsNumberReport componentData={componentData} />
            ),
          },
        ],
      },
      {
        componentName: orgBotsSubPages.ORG_BOTS_TOTAL_MESSAGES,
        title: 'Total de Mensagens',
        options: [
          {
            componentId:
              reportComponentsIds.orgBotsMessages.ORG_TOTAL_MESSAGES_REPORT,
            draggableId: 'org-messages',
            type: reportType.ABSOLUTE,
            typeText: reportTypeText[reportType.ABSOLUTE],
            component: (componentData) => (
              <OrgBotsTotalMessagesReport componentData={componentData} />
            ),
          },
          {
            componentId:
              reportComponentsIds.orgBotsMessages.ORG_TOTAL_MESSAGES_GRAPHIC,
            draggableId: 'org-messages',
            type: reportType.GRAPHIC,
            typeText: reportTypeText[reportType.GRAPHIC],
            component: (componentData) => (
              <OrgBotsTotalMessagesGraphic
                componentData={componentData}
                hideDownload
              />
            ),
          },
        ],
      },
      {
        componentName: orgBotsSubPages.ORG_BOTS_TOTAL_MESSAGES_BY_CHANNEL,
        title: 'Total de Mensagens por Canal',
        options: [
          {
            componentId:
              reportComponentsIds.orgBotsMessagesByChannel
                .ORG_TOTAL_MESSAGES_BY_CHANNEL_REPORT,
            draggableId: 'org-messages-by-channel',
            type: reportType.ABSOLUTE,
            typeText: reportTypeText[reportType.ABSOLUTE],
            component: (componentData) => (
              <OrgBotsTotalMessagesByChannelReport
                componentData={componentData}
              />
            ),
          },
          {
            componentId:
              reportComponentsIds.orgBotsMessagesByChannel
                .ORG_TOTAL_MESSAGES_BY_CHANNEL_GRAPHIC,
            draggableId: 'org-messages-by-channel',
            type: reportType.GRAPHIC,
            typeText: reportTypeText[reportType.GRAPHIC],
            component: (componentData) => (
              <OrgBotsTotalMessagesByChannelGraphic
                componentData={componentData}
                hideDownload
              />
            ),
          },
        ],
      },
      {
        componentName: orgBotsSubPages.ORG_BOTS_TOTAL_SESSIONS,
        title: 'Total de Sessões',
        options: [
          {
            componentId:
              reportComponentsIds.orgBotsSessions.ORG_TOTAL_SESSIONS_REPORT,
            draggableId: 'org-sessions',
            type: reportType.ABSOLUTE,
            typeText: reportTypeText[reportType.ABSOLUTE],
            component: (componentData) => (
              <OrgBotsTotalSessionsReport componentData={componentData} />
            ),
          },
          {
            componentId:
              reportComponentsIds.orgBotsSessions.ORG_TOTAL_SESSIONS_GRAPHIC,
            draggableId: 'org-sessions',
            type: reportType.GRAPHIC,
            typeText: reportTypeText[reportType.GRAPHIC],
            component: (componentData) => (
              <OrgBortsTotalSessionsGraphic
                componentData={componentData}
                hideDownload
              />
            ),
          },
        ],
      },
    ],
  },
  {
    id: orgPages.USERS,
    dashboardType: dashboardType.ORG,
    title: 'Usuários',
    reports: [
      {
        componentName: orgUsersSubPages.ORG_TOTAL_USERS,
        title: 'Total de Usuários',
        options: [
          {
            componentId:
              reportComponentsIds.orgTotalUsers.ORG_TOTAL_USERS_REPORT,
            draggableId: 'org-total-users',
            type: reportType.ABSOLUTE,
            typeText: reportTypeText[reportType.ABSOLUTE],
            component: (componentData) => (
              <OrgTotalUsersReport componentData={componentData} />
            ),
          },
        ],
      },
      // {
      //   componentName: orgUsersSubPages.ORG_LIST_USERS,
      //   title: 'Listagem de Usuários',
      //   options: [
      //     {
      //       componentId: reportComponentsIds.orgListUsers.ORG_LIST_USERS,
      //       draggableId: 'org-list-users',
      //       type: reportType.CUSTOM,
      //       typeText: reportTypeText[reportType.CUSTOM]('Lista'),
      //       component: (componentData) => (
      //         <OrgListUsers componentData={componentData} />
      //       ),
      //     },
      //   ],
      // },
      // {
      //   componentName: orgUsersSubPages.ORG_BOT_USERS,
      //   title: 'Bots por usuário',
      //   options: [
      //     {
      //       componentId: reportComponentsIds.orgBotsUser.ORG_BOT_USERS,
      //       draggableId: 'org-bot-users',
      //       type: reportType.CUSTOM,
      //       typeText: reportTypeText[reportType.CUSTOM]('Total'),
      //       component: (componentData) => (
      //         <OrgTotalBotsUser componentData={componentData} />
      //       ),
      //     },
      //   ],
      // },
    ],
  },
];
